import { render, staticRenderFns } from "./mf-table.vue?vue&type=template&id=5b6a358c"
import script from "./mf-table.vue?vue&type=script&lang=js"
export * from "./mf-table.vue?vue&type=script&lang=js"
import style0 from "./mf-table.vue?vue&type=style&index=0&id=5b6a358c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports